import { animate, state, style, transition, trigger } from '@angular/animations';

const EASING = '300ms cubic-bezier(0.25, 0.8, 0.5, 1)';

export const expandCollapseAnimation = trigger('expandCollapse', [
  state('collapsed', style({ height: '0px', overflow: 'hidden' })),
  state('expanded', style({ height: '*', overflow: 'visible' })),
  transition('collapsed => expanded', [
    style({ overflow: 'hidden' }),
    animate(EASING),
  ]),
  transition('expanded => collapsed', [
    style({ overflow: 'hidden' }),
    animate(EASING),
  ]),
]);
